module.exports = __webpack_public_path__ + "img/testpositionscore.de871f46.png";